import { darkTheme } from './darkTheme';
import { lightTheme } from './lightTheme';

export const theme = {
  dark: darkTheme,
  light: lightTheme
};
